import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M20 8.412l-12 12v3.586h3.586l12-12L20 8.412zm.707-2.121l5 5a1 1 0 010 1.414l-13 13a1 1 0 01-.707.293H7a1 1 0 01-1-1v-5a1 1 0 01.293-.707l13-13a1 1 0 011.414 0z" fill="#2E2E2E" /></svg>;
}
export default SvgComponent;